import {
  FETCH_PARK_DASHBOARD_REQUEST,
  FETCH_PARK_DASHBOARD_SUCCESS,
  FETCH_PARK_DASHBOARD_FAILURE,

  FETCH_ATTENDANCE_TREND_REQUEST,
  FETCH_ATTENDANCE_TREND_SUCCESS,
  FETCH_ATTENDANCE_TREND_FAILURE,

  FETCH_DAILY_ATTENDANCE_OVERVIEW_REQUEST,
  FETCH_DAILY_ATTENDANCE_OVERVIEW_SUCCESS,
  FETCH_DAILY_ATTENDANCE_OVERVIEW_FAILURE,

  FETCH_USER_DISTRIBUTION_DISTRICT_REQUEST,
  FETCH_USER_DISTRIBUTION_DISTRICT_SUCCESS,
  FETCH_USER_DISTRIBUTION_DISTRICT_FAILURE,
} from "../actions/dashboardParkActions";

const initialState = {
  parkDashboard: {},
  attendanceTrend: [],
  dailyAttendanceOverview: [],
  userDistributionByDistrict: [],
  loading: false,
  error: null,
};

const dashboardParkReducer = (state = initialState, action) => {
  switch (action.type) {
    // REQUEST
    case FETCH_PARK_DASHBOARD_REQUEST:
    case FETCH_ATTENDANCE_TREND_REQUEST:
    case FETCH_DAILY_ATTENDANCE_OVERVIEW_REQUEST:
    case FETCH_USER_DISTRIBUTION_DISTRICT_REQUEST:
      return { ...state, loading: true, error: null };

    // SUCCESS
    case FETCH_PARK_DASHBOARD_SUCCESS:
      return { ...state, loading: false, parkDashboard: action.payload || {} };

    case FETCH_ATTENDANCE_TREND_SUCCESS:
      return { ...state, loading: false, attendanceTrend: action.payload || [] };

    case FETCH_DAILY_ATTENDANCE_OVERVIEW_SUCCESS:
      return { ...state, loading: false, dailyAttendanceOverview: action.payload || [] };

    case FETCH_USER_DISTRIBUTION_DISTRICT_SUCCESS:
      return { ...state, loading: false, userDistributionByDistrict: action.payload || [] };

    // FAILURE
    case FETCH_PARK_DASHBOARD_FAILURE:
    case FETCH_ATTENDANCE_TREND_FAILURE:
    case FETCH_DAILY_ATTENDANCE_OVERVIEW_FAILURE:
    case FETCH_USER_DISTRIBUTION_DISTRICT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default dashboardParkReducer;
